import React, { Component } from "react";
import { connect } from "react-redux";

import { Table, Input } from "antd";
import { usrRole } from "../../utils/dataUtil";
import { API_BASE } from "../../utils/contrains";
import { getSSPAcademicYear } from "../../utils/dateUtil";
import {
  req_list_ssp_school_chair_handle,
  req_downloadfile_ssp_school_chair_handle,
} from "../../api";

class ChairHandleStatisticesList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    planAcademicYear: getSSPAcademicYear(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
  };

  componentWillMount() {
    this.api_item_list();
  }

  //////////
  api_item_list = async () => {
    const { planAcademicYear } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_school_chair_handle(
      userCode,
      userLevel,
      planAcademicYear,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items });
      console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
      });
    }
  };

  api_downloadfile_items = async () => {
    const { planAcademicYear } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    // download file data
    const fileUrl = await req_downloadfile_ssp_school_chair_handle(
      userCode,
      userLevel,
      planAcademicYear,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  //////////
  handle_data_refresh = () => {
    //this.api_list_studentsource_noloading();
    this.api_item_list();
    console.log("refresh");
  };

  handle_show_ui_modal = (modal, item) => {
    // console.log("handle_show_ui_modal");
    switch (modal) {
      case "download":
        this.api_downloadfile_items();
        break;
      default:
    }
  };

  //////////
  render() {
    const { data, loading, planAcademicYear } = this.state;
    const columns = [
      {
        title: "生源學校地區",
        width: 100,
        children: [
          {
            title: "地區",
            dataIndex: "CountyCityName",
            align: "center",
            width: 80,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}</div>,
              };
            },
          },
        ],
      },
      {
        title: "生管學院",
        children: [
          {
            title: "服設",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "A01DoneCityTotal",
                key: "A01DoneCityTotal",
                render(text, record) {
                  var textColor = "#c3d953";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "A01DepartCityTotal",
                key: "A01DepartCityTotal",
                render(text, record) {
                  var textColor = "#789017";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "美容",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "A02DoneCityTotal",
                key: "A02DoneCityTotal",
                render(text, record) {
                  var textColor = "#c3d953";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "A02DepartCityTotal",
                key: "A02DepartCityTotal",
                render(text, record) {
                  var textColor = "#789017";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "幼保",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "A03DoneCityTotal",
                key: "A03DoneCityTotal",
                render(text, record) {
                  var textColor = "#c3d953";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "A03DepartCityTotal",
                key: "A03DepartCityTotal",
                render(text, record) {
                  var textColor = "#789017";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "餐飲",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "A04DoneCityTotal",
                key: "A04DoneCityTotal",
                render(text, record) {
                  var textColor = "#c3d953";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "A04DepartCityTotal",
                key: "A04DepartCityTotal",
                render(text, record) {
                  var textColor = "#789017";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "生服",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "A05DoneCityTotal",
                key: "A05DoneCityTotal",
                render(text, record) {
                  var textColor = "#c3d953";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "A05DepartCityTotal",
                key: "A05DepartCityTotal",
                render(text, record) {
                  var textColor = "#789017";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "運休",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "A06DoneCityTotal",
                key: "A06DoneCityTotal",
                render(text, record) {
                  var textColor = "#c3d953";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "A06DepartCityTotal",
                key: "A06DepartCityTotal",
                render(text, record) {
                  var textColor = "#789017";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "國企",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "B01DoneCityTotal",
                key: "B01DoneCityTotal",
                render(text, record) {
                  var textColor = "#5b98db";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "B01DepartCityTotal",
                key: "B01DepartCityTotal",
                render(text, record) {
                  var textColor = "#0061ae";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "財金",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "B02DoneCityTotal",
                key: "B02DoneCityTotal",
                render(text, record) {
                  var textColor = "#5b98db";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "B02DepartCityTotal",
                key: "B02DepartCityTotal",
                render(text, record) {
                  var textColor = "#0061ae";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "資管",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "C03DoneCityTotal",
                key: "C03DoneCityTotal",
                render(text, record) {
                  var textColor = "#5b98db";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "C03DepartCityTotal",
                key: "C03DepartCityTotal",
                render(text, record) {
                  var textColor = "#0061ae";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "企管",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "D04DoneCityTotal",
                key: "D04DoneCityTotal",
                render(text, record) {
                  var textColor = "#5b98db";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "D04DepartCityTotal",
                key: "D04DepartCityTotal",
                render(text, record) {
                  var textColor = "#0061ae";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "應英",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "E01DoneCityTotal",
                key: "E01DoneCityTotal",
                render(text, record) {
                  var textColor = "#A4C5C3";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "E01DepartCityTotal",
                key: "E01DepartCityTotal",
                render(text, record) {
                  var textColor = "#00706a";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "旅館",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "E02DoneCityTotal",
                key: "E02DoneCityTotal",
                render(text, record) {
                  var textColor = "#A4C5C3";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "E02DepartCityTotal",
                key: "E02DepartCityTotal",
                render(text, record) {
                  var textColor = "#00706a";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "養生",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "E03DoneCityTotal",
                key: "E03DoneCityTotal",
                render(text, record) {
                  var textColor = "#A4C5C3";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "E03DepartCityTotal",
                key: "E03DepartCityTotal",
                render(text, record) {
                  var textColor = "#00706a";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
        ],
      },
      {
        title: "設計學院",
        children: [
          {
            title: "室設",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "C01DoneCityTotal",
                key: "C01DoneCityTotal",
                render(text, record) {
                  var textColor = "#f5b06e";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "C01DepartCityTotal",
                key: "C01DepartCityTotal",
                render(text, record) {
                  var textColor = "#f08519";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "視傳",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "C02DoneCityTotal",
                key: "C02DoneCityTotal",
                render(text, record) {
                  var textColor = "#f5b06e";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "C02DepartCityTotal",
                key: "C02DepartCityTotal",
                render(text, record) {
                  var textColor = "#f08519";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "商設",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "C03DoneCityTotal",
                key: "C03DoneCityTotal",
                render(text, record) {
                  var textColor = "#f5b06e";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "C03DepartCityTotal",
                key: "C03DepartCityTotal",
                render(text, record) {
                  var textColor = "#f08519";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "多動",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "C04DoneCityTotal",
                key: "C04DoneCityTotal",
                render(text, record) {
                  var textColor = "#f5b06e";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "C04DepartCityTotal",
                key: "C04DepartCityTotal",
                render(text, record) {
                  var textColor = "#f08519";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "時尚",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "C05DoneCityTotal",
                key: "C05DoneCityTotal",
                render(text, record) {
                  var textColor = "#f5b06e";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "C05DepartCityTotal",
                key: "C05DepartCityTotal",
                render(text, record) {
                  var textColor = "#f08519";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
        ],
      },
      {
        title: "藝術學院",
        children: [
          {
            title: "漫畫",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "C06DoneCityTotal",
                key: "C06DoneCityTotal",
                render(text, record) {
                  var textColor = "#f5b06e";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "C06DepartCityTotal",
                key: "C06DepartCityTotal",
                render(text, record) {
                  var textColor = "#f08519";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "美術(四)",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "D01DoneCityTotal",
                key: "D01DoneCityTotal",
                render(text, record) {
                  var textColor = "#dc4f9c";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "D01DepartCityTotal",
                key: "D01DepartCityTotal",
                render(text, record) {
                  var textColor = "#e40082";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "美術(七)",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "D17DoneCityTotal",
                key: "D17DoneCityTotal",
                render(text, record) {
                  var textColor = "#dc4f9c";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "D17DepartCityTotal",
                key: "D17DepartCityTotal",
                render(text, record) {
                  var textColor = "#e40082";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "音樂(七)",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "D02DoneCityTotal",
                key: "D02DoneCityTotal",
                render(text, record) {
                  var textColor = "#dc4f9c";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "D02DepartCityTotal",
                key: "D02DepartCityTotal",
                render(text, record) {
                  var textColor = "#e40082";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "舞蹈(四)",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "D03DoneCityTotal",
                key: "D03DoneCityTotal",
                render(text, record) {
                  var textColor = "#dc4f9c";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "D03DepartCityTotal",
                key: "D04DepartCityTotal",
                render(text, record) {
                  var textColor = "#e40082";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "舞蹈(七)",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "D37DoneCityTotal",
                key: "D37DoneCityTotal",
                render(text, record) {
                  var textColor = "#dc4f9c";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "D37DepartCityTotal",
                key: "D37DepartCityTotal",
                render(text, record) {
                  var textColor = "#e40082";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "行樂",
            children: [
              {
                title: "出席",
                align: "center",
                dataIndex: "D04DoneCityTotal",
                key: "D04DoneCityTotal",
                render(text, record) {
                  var textColor = "#dc4f9c";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
              {
                title: "校數",
                align: "center",
                dataIndex: "D04DepartCityTotal",
                key: "D04DepartCityTotal",
                render(text, record) {
                  var textColor = "#e40082";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: text > 0 ? textColor : "#000000",
                      },
                    },
                    children: <div>{text > 0 ? text : ""}</div>,
                  };
                },
              },
            ],
          },
        ],
      },
      {
        title: "旅遊學院",
        children: [],
      },
      {
        title: "合計",
        width: 180,
        children: [
          {
            title: "出席",
            dataIndex: "CountyCityYTotal",
            align: "center",
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: "校數",
            dataIndex: "CountyCityTotal",
            align: "center",
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: "出席率",
            dataIndex: "CountyCityRatio",
            align: "center",
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}%</div>,
              };
            },
          },
        ],
      },
    ];

    return (
      <>
        <Input
          placeholder="規劃年度"
          style={{
            width: 55,
            height: 39,
            margin: "0 5px",
            color: "red",
          }}
          onChange={(event) =>
            this.setState({ planAcademicYear: event.target.value })
          }
          value={planAcademicYear}
          readOnly={true}
          disabled={true}
        />
        <button
          className="btn btn-info"
          onClick={this.handle_data_refresh}
          style={{
            marginLeft: "2px",
            marginBottom: "4px",
            display: "inline-block",
          }}
        >
          <i className="fas fa-sync-alt"></i>
        </button>
        <button
          className="btn btn-info"
          onClick={() => this.handle_show_ui_modal("download", {})}
          style={{ marginLeft: "2px", marginBottom: "4px" }}
        >
          <i className="fas fa-cloud-download-alt"></i>
        </button>
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <p></p>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ChairHandleStatisticesList);
